export const environment = {
  production: true,
  fileServiceURL: "https://fileservice-testing02.input4you.be/api",
  backendURL: "https://gh-de-testing02.input4you.be/api",
  loginUrl: 'https://login.input4you.be/LoginAPI/'
};
